import { useQuery } from '@tanstack/react-query';
import { CallLog } from '../../../../components/speedToLead/CallLog';
import { CenteredSpinner } from '../../../../components/ui/Spinner';
import { confirmPortalCallOutcome, fetchPortalCalls, fetchPortalLeadHistory, fetchPortalRecordingUrl } from '../speedToLead/portalApi';

// THE CLUB'S OWN RECENT CALLS (moved from the old "Who we call" page into Setup, Speed to Lead). Playback and transcripts of ITS OWN
// calls. ⚠️ Read-only: a club cannot delete a recording (only Kyck can), so the log is given no onDelete.

export function PortalCallsSection({ accountId }: { accountId: string }) {
  const query = useQuery({ queryKey: ['portal-stl-calls', accountId], queryFn: () => fetchPortalCalls(accountId), retry: false });
  return (
    <section className="space-y-2" aria-label="Recent calls" data-testid="portal-calls">
      <h3 className="kc-label text-muted-foreground">Recent calls</h3>
      {query.isLoading && <CenteredSpinner />}
      {query.error && <p className="text-destructive">We could not load your calls just now.</p>}
      {query.data && (
        <CallLog
          calls={query.data.calls}
          loadPlayUrl={async (kind, id) => (await fetchPortalRecordingUrl(kind, id)).url}
          loadHistory={(kind, id, cursor) => fetchPortalLeadHistory({ call: `${kind}:${id}` }, cursor)}
          onConfirmOutcome={async (kind, id, outcome) => { await confirmPortalCallOutcome(kind, id, outcome); }}
        />
      )}
    </section>
  );
}
